import { withInstall } from '@ll-plus/utils'

import UploadDrag from './src/upload-drag.vue'

export const LlUploadDrag = withInstall(UploadDrag)
export default LlUploadDrag
export * from './src/upload-drag'

declare module 'vue' {
  export interface GlobalComponents {
    LlUploadDrag: typeof LlUploadDrag
  }
}
